import request from '@/common/request'
// import file from '@/common/fileDownload'
/**
 *  create 增
 *  delete 删
 *  update 改
 *  query  查
 */
export default {
  // 列表获取
  restList: (data) => {
    return request({
      url: '/v1/task/restList',
      method: 'post',
      data,
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/modules/TaskAssociationTable.js